export default __webpack_public_path__ + "locales/pl/VersionHistory.json?hash=bfffd5f7a750bf0b1788e014513fe4ee";